const style = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    gap: 20,
  },
  groupCard: {
    minWidth: 250,
  },
  groupHeaderRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  aboutInfoButton: {
    padding: '0 8px',
    minWidth: 30,
    minHeight: 28,
    lineHeight: 1,
  },
  clickable: { cursor: 'pointer' },
  inputAndAddButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'spaced-between',
    alignItems: 'center',
    paddingBottom: 5,
    paddingTop: 5,
    marginTop: 20,
  },
  manageFieldsNewName: {
    alignItems: 'center',
    textAlign: 'center',
    width: '97%',
    marginRight: 5,
    marginLeft: 5,
  },
  centeredText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    textAlign: 'center',
  },
  aboutGroupsPanel: {
    paddingTop: 70,
    flex: 1,
    minWidth: 260,
    textAlign: 'center',
  },
  aboutGroupsTitle: {
    fontSize: 36,
    fontWeight: 700,
    lineHeight: '36px',
    marginBottom: 12,
    textAlign: 'center',
  },
  aboutGroupsList: {
    margin: '0 auto',
    paddingLeft: 0,
    listStylePosition: 'inside',
    lineHeight: '30px',
    textAlign: 'center',
  },
  aboutGroupsTitleMobile: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 8,
    textAlign: 'center',
  },
  aboutGroupsListMobile: {
    margin: '0 auto',
    paddingLeft: 0,
    listStylePosition: 'inside',
    lineHeight: '22px',
    fontSize: 14,
    textAlign: 'center',
  },
};
export default style;
